import React from "react";
import Styles from "./LorryOneLineInfo.module.scss";

// Helpers
import {
    LORRY_CATEGORIES_ENUM,
    VehicleTypeBodyTypeMap,
    getLorryDetailsByType
} from "@vahak/core/dist/constants/lorryTypes";
import DotSeparated from "@vahak/core/dist/components/dot-separated/DotSeparated";

interface LorryOneLineInfoProps {
    lorryType: number;
    lorryBodyType: number;
    lorryCapacity: number;
    lorrySize: number;
    lorryTyres: number;
    lorrySizeText: string;
    showLorryType?: boolean;
}

const LorryOneLineInfo = ({
    lorryBodyType,
    lorryCapacity,
    lorrySize,
    lorrySizeText,
    lorryType,
    lorryTyres,
    showLorryType
}: LorryOneLineInfoProps) => {
    const bodyText = VehicleTypeBodyTypeMap["load"]?.[lorryType as LORRY_CATEGORIES_ENUM]?.[lorryBodyType];
    const renderLorryInfo = () => {
        let nodes = [];
        if (showLorryType) {
            const lorry = getLorryDetailsByType(lorryType);
            nodes.push(lorry?.label);
        }
        switch (lorryType) {
            case LORRY_CATEGORIES_ENUM.LCV:
                nodes.push(bodyText);
                lorrySize && nodes.push(`${lorrySize} ${lorrySizeText || "Ft"}`);
                lorryCapacity && nodes.push(`${lorryCapacity} Tonne(s)`);
                return <DotSeparated nodes={nodes} />;

            case LORRY_CATEGORIES_ENUM.TANKER:
                nodes.push(bodyText);
                lorryCapacity && nodes.push(`${lorryCapacity} KL`);
                return <DotSeparated nodes={nodes} />;

            case LORRY_CATEGORIES_ENUM.CONTAINER:
                lorrySize && nodes.push(`${lorrySize} ${lorrySizeText || "Ft"}`);
                lorryCapacity && nodes.push(`${lorryCapacity} Tonne(s)`);
                return <DotSeparated nodes={nodes} />;

            case LORRY_CATEGORIES_ENUM.TRAILER:
                lorrySize && nodes.push(`${lorrySize} ${lorrySizeText || "Ft"}`);
                lorryCapacity && nodes.push(`${lorryCapacity} Tonne(s)`);
                return <DotSeparated nodes={nodes} />;

            case LORRY_CATEGORIES_ENUM.HYVA:
                lorryTyres && nodes.push(`${lorryTyres} tyres`);
                lorryCapacity && nodes.push(`${lorryCapacity} Tonne(s)`);
                return <DotSeparated nodes={nodes} />;

            case LORRY_CATEGORIES_ENUM.TRUCK:
                nodes.push(bodyText);
                lorryTyres && nodes.push(`${lorryTyres} tyres`);
                lorrySize && nodes.push(`${lorrySize} Ft`);
                lorryCapacity && nodes.push(`${lorryCapacity} Tonne(s)`);

                return <DotSeparated nodes={nodes} wrapperClassName={Styles.wrapper} />;
        }
        return "LorryInfo";
    };

    return <div className={Styles.main}>{renderLorryInfo()}</div>;
};

export default LorryOneLineInfo;
